'use es6';

import { hasOpenThread } from '../../threads/selectors/hasOpenThread';
import { navigateToMostRecentThread } from '../../threads/actions/ThreadActions';
import { getKnowledgeBaseEnabled } from '../../selectors/widgetDataSelectors/getKnowledgeBaseEnabled';
import { loadStagedThread } from '../../navigation/actions/loadStagedThread';
import { navigateToThreadListKnowledgebase } from '../../navigation/actions/navigateToThreadListKnowledgebase';
import { THREAD_LIST, THREAD_VIEW } from 'conversations-visitor-experience-components/visitor-widget/constants/views';
import { getIsUngatedForCustomerAgentPrompts } from '../../widget-data/selectors/widgetDataSelectors';
export function navigateToInitialView() {
  return (dispatch, getState) => {
    const isKnowledgeBaseWidget = getKnowledgeBaseEnabled(getState());
    const isUngatedForCustomerAgentPrompts = getIsUngatedForCustomerAgentPrompts(getState());
    if (hasOpenThread(getState())) {
      dispatch(navigateToMostRecentThread());
    } else if (isKnowledgeBaseWidget) {
      dispatch(navigateToThreadListKnowledgebase());
      dispatch(loadStagedThread({
        view: isUngatedForCustomerAgentPrompts ? THREAD_VIEW : THREAD_LIST
      }));
    } else {
      dispatch(loadStagedThread());
    }
  };
}